import classNames from 'classnames'

import styles from './Toggle.module.scss'

export interface ToggleProps {
  name: string
  value: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

export const Toggle: React.FC<ToggleProps> = ({ name, value, disabled, onChange }) => {
  return (
    <div
      className={classNames(styles.checkbox, {
        [styles.active]: value,
        [styles.disabled]: disabled,
      })}
    >
      <input
        type='checkbox'
        id={name}
        className={value ? 'checked' : ''}
        checked={value}
        disabled={disabled}
        onChange={(e) => {
          onChange(e.target.checked)
        }}
      />
      <div className={styles.selector} />
    </div>
  )
}
